export default __webpack_public_path__ + "static/media/template12.b5365221.jpg";